// extracted by mini-css-extract-plugin
export default {"container":"Education_container__cOS0L","smallText":"Education_smallText__YyDYh","left":"Education_left__U6Izk","right":"Education_right__yrHJW"};